import { render, staticRenderFns } from "./TotalScore.vue?vue&type=template&id=a2bac254&scoped=true"
import script from "./TotalScore.vue?vue&type=script&lang=js"
export * from "./TotalScore.vue?vue&type=script&lang=js"
import style0 from "./TotalScore.vue?vue&type=style&index=0&id=a2bac254&prod&scoped=true&lang=css"
import style1 from "./TotalScore.vue?vue&type=style&index=1&id=a2bac254&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bac254",
  null
  
)

export default component.exports